import React from 'react';
import { cn } from '../../../lib/utils';

export interface IAgentHelperMainLayoutProps {
  className?: string;
  children?: React.ReactNode;
}

export const AgentHelperMainLayout = ({ className, children }: IAgentHelperMainLayoutProps) => {
  return (
    <div className={cn('flex flex-col h-full w-full', className)}>
      {children}
    </div>
  );
};

interface ISlotProps {
  className?: string;
  children?: React.ReactNode;
}

const TopBar = ({ className, children }: ISlotProps) => {
  return (
    <div className={cn('h-[52px] shrink-0 bg-white border-b border-[#E0E0E0] flex items-center', className)}>
      {children}
    </div>
  );
};
TopBar.displayName = 'AgentHelperMainLayout.TopBar';
AgentHelperMainLayout.TopBar = TopBar;

const Main = ({ className, children }: ISlotProps) => {
  return (
    <div className={cn('flex flex-1 min-h-0', className)}>
      {children}
    </div>
  );
};
Main.displayName = 'AgentHelperMainLayout.Main';
AgentHelperMainLayout.Main = Main;

const SideBar = ({ className, children }: ISlotProps) => {
  return (
    <div className={cn('w-[280px] shrink-0 bg-white border-r border-[#E0E0E0] flex flex-col', className)}>
      {children}
    </div>
  );
};
SideBar.displayName = 'AgentHelperMainLayout.SideBar';
AgentHelperMainLayout.SideBar = SideBar;

const Content = ({ className, children }: ISlotProps) => {
  return (
    <div className={cn('flex-1 min-w-0 bg-[#F5F7FA] overflow-auto', className)}>
      {children}
    </div>
  );
};
Content.displayName = 'AgentHelperMainLayout.Content';
AgentHelperMainLayout.Content = Content;
